import { useCloudCredentials } from '@/react/portainer/settings/sharedCredentials/cloudSettings.service';
import { CredentialType } from '@/react/portainer/settings/sharedCredentials/types';
import { EnvironmentId } from '@/react/portainer/environments/types';

import { Loading } from '@@/Widget';

import { SSHInstallForm } from './SSHInstallForm';
import { useActiveConnectionTest } from './queries/useActiveConnectionTest';

interface Props {
  asyncMode: boolean;
  onInstalled(environmentIds: Array<EnvironmentId>): void;
}

export function SSHInstall({ asyncMode, onInstalled }: Props) {
  const credentialsQuery = useCloudCredentials({
    select: (credentials) =>
      credentials.filter((c) => c.provider === CredentialType.SSH),
  });
  const activeTestQuery = useActiveConnectionTest();

  if (credentialsQuery.isLoading || activeTestQuery.isLoading) {
    return <Loading />;
  }

  const activeTest = activeTestQuery.data;

  return (
    <SSHInstallForm
      asyncMode={asyncMode}
      credentials={credentialsQuery.data ?? []}
      activeTest={activeTest}
      onInstalled={onInstalled}
    />
  );
}
